// extracted by mini-css-extract-plugin
export default {"card-wrapper":"CreateMediaCard_card-wrapper__R5x1e","card-inner-wrapper":"CreateMediaCard_card-inner-wrapper__ix16w","card-plus":"CreateMediaCard_card-plus__SimCv"};